<fullscreen-page>

  <content-column helpSwitch="true" look="light">
    <div slot="content" class="p-2 flex-fill overflow-hidden">
      <dx-data-grid [dataSource]="brands"
                    keyExpr="id"
                    [showBorders]="true"
                    [rowAlternationEnabled]="true"
                    noDataText="{{ 'keine Marken vorhanden' | translate }}"
                    (onToolbarPreparing)="onContentToolbarPreparing($event)"
                    (onRowRemoved)="onRowRemoved($event)"
                    [selection]="{ mode: 'multiple', showCheckBoxesMode: 'always', allowSelectAll: false}"
                    (onSelectionChanged)="onSelectionChanged($event)">
        <dxo-search-panel [visible]="true"
                          [width]="240"
                          placeholder="Suche …">
        </dxo-search-panel>
        <dxo-search enabled="true"></dxo-search>
        <dxo-editing mode="row"
                     [allowAdding]="false"
                     [allowUpdating]="false"
                     [allowDeleting]="true"></dxo-editing>
        <div *dxTemplate="let toolbaritem of 'addBrandTemplate'">
          <dx-button stylingMode="text" type="default" icon="add" text="{{ 'Neue Marke' | translate }}" (onClick)="addOrUpdateBrand()"></dx-button>
        </div>
        <div *dxTemplate="let toolbaritem of 'applyBrandChangesButtonTemplate'">
          <div id="applyDataSourceChangesButton" class="d-flex gap-2">
            <dx-button stylingMode="text"
                       [disabled]="!isApplyBrandChangesButtonActiv()"
                       type="default"
                       [text]="applyBrandChangesButtonText()"
                       [hint]="applyBrandChangesButtonHint"
                       (onClick)="startMacroDialogVisible=true">
            </dx-button>
         </div>
          </div>
        <dxi-column caption="{{ 'Logo' | translate }}" dataField="logoFile" cellTemplate="brandLogoCellTemplate">
          <div *dxTemplate="let cell of 'brandLogoCellTemplate'">
            <img *ngIf="cell.value"
                 [src]="cell.value"
                 alt="Logo Preview"
                 style="height: 30px;"/>
            </div>
        </dxi-column>
        <dxi-column caption="{{ 'Markenname' | translate }}" dataField="name"></dxi-column>
        <dxi-column caption="{{ 'Website' | translate }}" dataField="website" cellTemplate="websiteCellTemplate">
          <div *dxTemplate="let cell of 'websiteCellTemplate'">
            <a *ngIf="cell.value" [href]="cell.value" target="_blank" rel="noopener noreferrer">
              {{ cell.value }}
            </a>
          </div>

        </dxi-column>
        
        <dxi-column caption="" width="30" cellTemplate="editTemplate">
          <div *dxTemplate="let d of 'editTemplate'">
            <a (click)="addOrUpdateBrand(d.data)"
               class="dx-icon-edit mr-2"
               title="{{ 'Marke bearbeiten' | translate }}"></a>
          </div>
        </dxi-column>
        
      </dx-data-grid>
    </div>
  </content-column>

    
</fullscreen-page>>

<dx-popup [(visible)]="startMacroDialogVisible"
          [width]="400"
          [height]="250"
          [title]="hasSelection ? ('Synchronisierung starten' | translate) : ('Alle Änderungen anwenden' | translate)"
          [hideOnOutsideClick]="true">

    <dxi-popup-toolbar-item toolbar="bottom"
                            location="after"
                            widget="dxButton"
                            [options]="{ text: hasSelection ? ('Synchronisierung starten' | translate) : ('Alle Änderungen anwenden' | translate), onClick: applyBrandChanges }">
    </dxi-popup-toolbar-item>
    <div *dxTemplate="let data of 'content'">
        <p>{{ 'Wird kein Startdatum angegeben, wird das Makro direkt ausgeführt.' | translate}}</p>
        <div class="dx-field">
            <div class="dx-field-label">{{ 'Startzeitpunkt' | translate }}</div>
            <div class="dx-field-value">
                <dx-date-box [(value)]="selectedMacroStartDate"
                             type="datetime"
                             displayFormat="dd.MM.yyyy HH:mm">
                </dx-date-box>
            </div>
        </div>
    </div>
</dx-popup>

<dx-popup [showTitle]="true"
          [title]="editMode ? ('Marke ändern' | translate) : ('Marke anlegen' | translate)"
          [dragEnabled]="true"
          [hideOnOutsideClick]="true"
          [showCloseButton]="true"
          [(visible)]="addOrUpdateVisible"
          contentTemplate="popupContent"
           width="50%"              
           min-width="320"
           max-width="800"
           height="70%"              
           max-height="90vh">
  <dxi-popup-toolbar-item
    toolbar="bottom"
    location="after"
    widget="dxButton"
    [options]="{ stylingMode: 'outlined', text: editMode ? ('Marke ändern' | translate) : ('Marke anlegen' | translate), onClick: addBrand }">
  </dxi-popup-toolbar-item>

  <div *dxTemplate="let data of 'popupContent'">
    <dx-responsive-box [cols]="[{ ratio:1 }, { ratio:1 }]"
                       [rows]="[{ baseSize: '20%' }, { ratio:1 }]"
                       width="100%" height="100%">

      <dxi-item [location]="{ row:0, col:0 }" class="card-compact">
        <ng-template dxTemplate="content">
          <div class="dx-card">
            <div class="dx-fieldset">
              <div class="dx-fieldset-header">{{ 'Markeninformationen' | translate }}</div>
              <div class="dx-field">
                <div class="dx-field-label">{{ 'Markename' | translate }}</div>
                <div class="dx-field-value">
                  <dx-text-box [(value)]="newOrUpdateBrand.name" [showClearButton]="true">
                    <dx-validator [validationGroup]="'brandForm'">
                      <dxi-validation-rule type="required"
                                           message="Markenname ist ein Pflichtfeld">
                      </dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </div>
              </div>
              <div class="dx-field">
                <div class="dx-field-label">{{ 'Zugewiesen' | translate }}</div>
                <div class="dx-field-value">
                  <dx-drop-down-box class="flex-grow-1 np-highlight"
                                    [acceptCustomValue]="true"
                                    [(value)]="newOrUpdateBrand.dataSources"
                                    [dataSource]="productDataSources"
                                    displayExpr="name"
                                    valueExpr="id">
                    <div *dxTemplate="let item of 'content'">

                      <dx-data-grid [dataSource]="productDataSources"
                                    keyExpr="id"
                                    [columns]="['name']"
                                    [selection]="{ mode: 'multiple' }"
                                    [hoverStateEnabled]="true"
                                    [paging]="{ enabled: true, pageSize: 10 }"
                                    [filterRow]="{ visible: true }"
                                    [scrolling]="{ mode: 'infinite' }"
                                    [height]="345"
                                    (onSelectionChanged)="onDataSourceSelectionChanged($event)">
                      </dx-data-grid>
                    </div>
                  </dx-drop-down-box>
                </div>
              </div>
              <div class="dx-field">
                <div class="dx-field-label">{{ 'Website' | translate }}</div>
                <div class="dx-field-value">
                  <dx-text-box [(value)]="newOrUpdateBrand.website" [showClearButton]="true">
                    <dx-validator [validationGroup]="'brandForm'">
                      <dxi-validation-rule type="pattern"
                                           pattern="^(https?:\/\/)?([\w\-]+\.)+[\w\-]{2,}(\/[^\s]*)?$"
                                           message="Bitte eine gültige URL eingeben">
                      </dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </dxi-item>

      <dxi-item [location]="{ row:0, col:1 }" class="card-compact">
        <ng-template dxTemplate="content">
          <div class="dx-card card-compact">
            <div class="dx-fieldset">
              <div class="dx-fieldset-header">{{ 'Logo' | translate }}</div>
              <div class="d-flex flex-column justify-content-center align-items-center gap-3">
                <span *ngIf="!newOrUpdateBrand.logoFile"
                      class="glyphicon glyphicon-picture"
                      [ngStyle]="{ fontSize: '25ch', marginBlock: '2rem' }"></span>
                <img *ngIf="newOrUpdateBrand.logoFile"
                     [src]="newOrUpdateBrand.logoFile"
                     alt="Logo Preview"
                     class="logo-preview mb-2" />
                <dx-file-uploader uploadUrl="api/Brand/UploadLogo"
                                  [allowedFileExtensions]="['.jpg', '.jpeg', '.png', '.gif', '.svg']"
                                  [uploadHeaders]="uploadHeaders"
                                  [uploadCustomData]="{
                                            brandId: newOrUpdateBrand.id,
                                            customerId: loginService.currentUser.customerId
                                          }"
                                  [multiple]="false"
                                  accept="*"
                                  (onUploaded)="onUploaded($event)"
                                  (onBeforeSend)="onBeforeSendUpload($event)"
                                  [(value)]="value"
                                  uploadMode="instantly"></dx-file-uploader>
              </div>
            </div>
          </div>
        </ng-template>
      </dxi-item>

      <dxi-item [location]="{ row:1, col:0, colspan:2 }">
        <ng-template dxTemplate="content">
          <div class="dx-card">
            <div class="dx-fieldset">
              <div class="dx-fieldset-header">{{ 'Beschreibung' | translate }}</div>
                <dx-html-editor class="scroll-editor" [(value)]="newOrUpdateBrand.description" height="100%" width="100%">
                  <dxo-toolbar>
                    <dxi-item name="undo"></dxi-item>
                    <dxi-item name="redo"></dxi-item>
                    <dxi-item name="separator"></dxi-item>
                    <dxi-item name="bold"></dxi-item>
                    <dxi-item name="italic"></dxi-item>
                    <dxi-item name="underline"></dxi-item>
                    <dxi-item name="separator"></dxi-item>
                    <dxi-item name="alignLeft"></dxi-item>
                    <dxi-item name="alignCenter"></dxi-item>
                    <dxi-item name="alignRight"></dxi-item>
                    <dxi-item name="separator"></dxi-item>
                    <dxi-item name="header" [acceptedValues]="[1, 2, 3, 4, 5, false]"></dxi-item>
                    <dxi-item name="separator"></dxi-item>
                    <dxi-item name="orderedList"></dxi-item>
                    <dxi-item name="bulletList"></dxi-item>
                  </dxo-toolbar>
                </dx-html-editor>
            </div>
          </div>
        </ng-template>
      </dxi-item>
    </dx-responsive-box>
  </div>
</dx-popup>
